export function isCoPilotExecutionAgent(agentName?: string | null): boolean {
  if (!agentName) {
    return false;
  }

  const normalized = agentName.toLowerCase().replace(/[\s_-]/g, '');
  return normalized === 'copilot';
}
